// extracted by mini-css-extract-plugin
export default {"layoutSection":"LayoutSection_layoutSection__K0JQ4"};